import { render, staticRenderFns } from "./full-get.vue?vue&type=template&id=6c4f5394&scoped=true"
import script from "./full-get.vue?vue&type=script&lang=js"
export * from "./full-get.vue?vue&type=script&lang=js"
import style0 from "./full-get.vue?vue&type=style&index=0&id=6c4f5394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f5394",
  null
  
)

export default component.exports